import { render, staticRenderFns } from "./TypeForm.vue?vue&type=template&id=8ca68bb8&scoped=true"
import script from "./TypeForm.vue?vue&type=script&lang=js"
export * from "./TypeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ca68bb8",
  null
  
)

export default component.exports